// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.slide-height-transition[data-v-16e8aee2] {\n\t-webkit-transition: height 0.25s, padding-top 0.25s, padding-bottom 0.25s;\n\ttransition: height 0.25s, padding-top 0.25s, padding-bottom 0.25s;\n\t-webkit-box-sizing: border-box;\n\t        box-sizing: border-box;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
